import { Box, Grid, Paper, Stack, Tooltip, Typography, Button } from '@mui/material'
import React, {useState} from 'react'
import { Colors } from '../../../Styles/Colors'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'
import { ImagePaths } from '../../../Utility/ImagePaths'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { useHistory } from 'react-router-dom';

const reportsList = [
    {
        title: 'Inventory Reports', icon: ImagePaths.corporateConfig.default,
        // Access : CheckAccessFunc("Standalone Pharmacy", "Reports", "Sales", null, "Tab"),
        reports: [
            { report_names: 'Stock Value Report', path: '/StoreReports/StockValue' },
            { report_names: 'Stock Report', path: '/StoreReports/StockReport' },
            { report_names: 'Short Expiry', path: '/StoreReports/ShortExpiry' },
            { report_names: 'Low Stock', path: '/StoreReports/StockLowStock' },
        ]
    },
    {
        title: 'Purchase Reports', icon: ImagePaths.opConfig.default,
        // Access : CheckAccessFunc("Standalone Pharmacy", "Reports", "Purchase", null, "Tab"),
        reports: [
            { report_names: 'Purchase Report', path: '/StoreReports/PurchaseReport' },
            { report_names: 'Purchase Return Report', path: '/StoreReports/PurchaseReturnReport' },
            { report_names: 'Purchase HSN Report', path: '/StoreReports/PurchaseHSNReport' },
            { report_names: 'Purchase GST Report', path: '/StoreReports/PurchaseGSTReport' },
            { report_names: 'Purchase Return HSN Report', path: '/StoreReports/PurchaseReturnHSNReport' },
            { report_names: 'Purchase Return GST Report', path: '/StoreReports/PurchaseReturnGSTReport' },
            { report_names: 'Vendor Performance', path: '/StoreReports/VendorPerformance' },
        ]
    },
    {
        title: 'Tranfer Reports', icon: ImagePaths.opConfig.default,
        // Access : CheckAccessFunc("Standalone Pharmacy", "Reports", "Purchase", null, "Tab"),
        reports: [
            { report_names: 'Transfer List', path: '/StoreReports/TransferList' },
            { report_names: 'Return Transfer Sublocation', path: '/StoreReports/ReturnTransSubLoc' },
        ]
    },
]

export default function StoreReportsHome() {
    const history = useHistory()
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');

    const reportData = (item) => {
        return (
            <>
                <Box component={'div'} className='eMed_rts_card'>
                    <Paper className='eMed_rts_content'>
                        <Grid container className='eMed_rts_content_top'>
                            <Grid item xs={12} className='eMed_rts_txt_one'>
                                <Stack display={'flex'} flexDirection='row'>
                                    <img src={item?.icon} alt="" className='eMed_rts_icon' />
                                    <Typography fontWeight={'600'}>{item?.title}</Typography>
                                </Stack>
                            </Grid>
                            <Grid item xs={12} className='eMed_rts_content_btm'>
                                {item?.reports.map((list, index) => {
                                    return <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                        <Typography display={index === 0 ? "none" : 'inline'} color={Colors.themeDark}>|</Typography>
                                        <Button key={index} className='eMed_reports_text_btn' emed_tid={`Phm_rpt_${list.report_names.replace(/ /g, "")}`}
                                            onClick={() => {
                                                history.push({ pathname: list.path })
                                            }}>{list.report_names}</Button>
                                    </Box>
                                })}
                            </Grid>
                        </Grid>
                    </Paper>
                </Box>
            </>
        )
    }
    const msgClose = () => {
        seterrorMsg(false)
        seterrorMsgText("")
    }
    return (
        <Box component={'div'} className='eMed_rts_home_container' overflow={'scroll'}>
            <Box position={'static'}>
                <Typography fontWeight={'600'} padding='1vw' borderBottom={'1px solid lightgray'}>{"Reports"}</Typography>
            </Box>
            <Box>
                {reportsList.map((item, index) => {
                    // if (CheckAccessFunc(myUser.pharmacy_type === 'Inhouse Pharmacy' ? "Pharmacy" : "Standalone Pharmacy", "Reports", item?.title, null, "Tab").viewAccess) {
                    return (<Stack key={index}>{reportData(item)}</Stack>)
                    // }
                })}
            </Box>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
        </Box>
    )
}
